export default {"src":"/_next/static/media/medrm.55a06701.svg","height":174,"width":174,"blurWidth":0,"blurHeight":0};